import { render } from "./ComplianceDocuments.vue?vue&type=template&id=67a635d2&scoped=true"
import script from "./ComplianceDocuments.vue?vue&type=script&lang=js"
export * from "./ComplianceDocuments.vue?vue&type=script&lang=js"

import "./ComplianceDocuments.vue?vue&type=style&index=0&id=67a635d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a635d2"]])

export default __exports__